export default function () {
  return typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function';
}